export enum ProductName {
  CREDIT = 'credit',
  DEBT_CONSOLIDATION = 'debtConsolidation'
}
